import axios from "axios";
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.product;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));


//get all
const getAllAccidentProducts = async (id) => {
    let response;
      //create configuration with token
      const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl+'/'+id+'/packages', config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


export default {
    getAllAccidentProducts
}
